import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { SubscriptionStatistics } from "../../../models/dashboard/subscriptions/subscriptions";

const getSubscriptionStatistics = (): Promise<SubscriptionStatistics> => {
    return adminHttpClient.get(`/api/Admin/AdminSubscriptions/get-subscription-statistics`)
}

export default getSubscriptionStatistics;